import { render } from "./ChatClaim.vue?vue&type=template&id=310d8840&scoped=true"
import script from "./ChatClaim.vue?vue&type=script&lang=js"
export * from "./ChatClaim.vue?vue&type=script&lang=js"

import "./ChatClaim.vue?vue&type=style&index=0&id=310d8840&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310d8840"]])

export default __exports__